// Inject (or update) JSON-LD structured data into <head>.
import { useEffect } from "react";

export default function StructuredData({ data, id = "ld-json" }) {
  useEffect(() => {
    if (!data) return undefined;
    const tagId = `${id}-${Math.random().toString(36).slice(2, 8)}`;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = tagId;
    try {
      script.text = JSON.stringify(data);
    } catch (e) {
      return undefined;
    }
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(tagId);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, [data, id]);
  return null;
}
